import * as React from "react";
const ProtectionIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#protection_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49 9a3.018 3.018 0 0 0-3 3v16l-4.806 4.844a.972.972 0 0 1-1.604.173 1.25 1.25 0 0 1 0-1.747l4.056-4.127a2.148 2.148 0 0 0 0-3 2.061 2.061 0 0 0-2.948 0L32.83 32.15A6.396 6.396 0 0 0 31.017 37H31v15h9v-9.655a6.228 6.228 0 0 0 1.665-1.207l9.47-9.616A3.027 3.027 0 0 0 52 29.4V12a3.018 3.018 0 0 0-3-3ZM23.17 32.149l-7.868-8.006a2.061 2.061 0 0 0-2.948 0 2.148 2.148 0 0 0 0 3l4.056 4.127a1.25 1.25 0 0 1 0 1.747 1.201 1.201 0 0 1-1.717 0L10 28V12a3.018 3.018 0 0 0-3-3 3.018 3.018 0 0 0-3 3v17.4c0 .794.31 1.556.866 2.122l9.47 9.616A6.23 6.23 0 0 0 16 42.345V52h9V37h-.017a6.395 6.395 0 0 0-1.813-4.851ZM28 22a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "protection_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default ProtectionIcon;